module.exports = __webpack_public_path__ + "static/media/CHAP02-TITRE.091441e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skew/img/CHAP02-TITRE.png
// module id = 297
// module chunks = 0